// PHASE_4 — Campaign click tracking (web).
//
// Mirror of mobile/src/app/utils/campaign-tracking.ts: when a notification
// deep-link resolves and carries `?campaign_id=cmp_…`, ping the public BFF
// endpoint POST /tracking/campaigns/{id}/clicked. Fire-and-forget; errors are
// logged but never block the navigation. No auth required.

import { getBffBaseUrl } from "@/app/api/auth-client";

const CAMPAIGN_ID_RE = /^cmp_[0-9A-HJKMNP-TV-Z]{26}$/;

export function extractCampaignId(params: URLSearchParams): string | null {
  const raw = params.get("campaign_id")?.trim();
  if (!raw) return null;
  if (!CAMPAIGN_ID_RE.test(raw)) return null;
  return raw;
}

export async function trackCampaignClickIfPresent(
  params: URLSearchParams,
  extras?: { userId?: string | null; notificationId?: string | null },
): Promise<boolean> {
  const id = extractCampaignId(params);
  if (!id) return false;
  try {
    const base = getBffBaseUrl().replace(/\/+$/, "");
    if (!base) return false;
    const url = `${base}/tracking/campaigns/${id}/clicked`;
    const body: Record<string, string> = {};
    if (extras?.userId) body.user_id = extras.userId;
    if (extras?.notificationId) body.notification_id = extras.notificationId;
    // sendBeacon survives navigation/unload; falls back to fetch keepalive.
    if (
      typeof navigator !== "undefined" &&
      typeof navigator.sendBeacon === "function"
    ) {
      const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
      navigator.sendBeacon(url, blob);
      return true;
    }
    await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    });
    return true;
  } catch (err) {
    console.warn("[campaign-tracking] click report failed", err);
    return false;
  }
}
